// radio-label.component.ts
import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-radio-label',
  standalone: true,
  imports: [CommonModule, FormsModule],
  template: `
    <label class="flex items-center gap-3 w-full cursor-pointer">
      <div class="relative w-5 h-5 flex items-center justify-center">
        <div *ngIf="value === radioValue" class="fas fa-circle-dot text-theme-primary fa-lg">
        </div>
        <div *ngIf="value !== radioValue" class="far fa-circle text-theme-primary fa-lg">
        </div>
        <input type="radio"
               [name]="name"
               [value]="radioValue"
               [checked]="value === radioValue"
               (click)="onInputChange($event)"
               class="hidden">
      </div>
      <ng-content></ng-content>
    </label>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioLabelComponent),
      multi: true
    }
  ]
})
export class RadioLabelComponent implements ControlValueAccessor {
  @Input() name = '';
  @Input() radioValue: any;

  value: any;
  disabled = false;
  onChange: any = () => {};

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    // Required by interface but unused
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onInputChange(event: Event): void {
    event.stopPropagation();
    if (!this.disabled) {
      this.value = this.radioValue;
      this.onChange(this.value);
    }
  }
}
